"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseImprovedDefect = parseImprovedDefect;
const PRICE_LINE = /(?:^|\n)\s*\*{0,2}\s*(?:עלות\s+משוערת|עלות|מחיר)\s*\*{0,2}\s*:\s*\*{0,2}\s*([^\n]+)/iu;
const JSON_FENCE = /^```(?:json)?\s*([\s\S]*?)\s*```$/iu;
function parseRepairPrice(value) {
    if (typeof value === 'number')
        return value;
    if (typeof value === 'string' && value.trim())
        return Number(value);
    return undefined;
}
function parseStructuredDefect(value) {
    const candidate = value.trim().match(JSON_FENCE)?.[1] ?? value.trim();
    try {
        const parsed = JSON.parse(candidate);
        if (typeof parsed.content !== 'string' || !parsed.content.trim())
            return undefined;
        const repairPrice = parseRepairPrice(parsed.repairPrice);
        return {
            content: parsed.content.trim(),
            ...(typeof repairPrice === 'number' && Number.isFinite(repairPrice) && repairPrice > 0
                ? { estimatedPrice: Math.round(repairPrice) }
                : {}),
        };
    }
    catch {
        return undefined;
    }
}
function parseImprovedDefect(value) {
    const structured = parseStructuredDefect(value);
    if (structured)
        return structured;
    const priceLine = value.match(PRICE_LINE);
    const content = value.replace(PRICE_LINE, '').trim();
    const firstAmount = priceLine?.[1].match(/[\d,.]+/u)?.[0];
    const estimatedPrice = firstAmount ? Number(firstAmount.replace(/\D/g, '')) : undefined;
    return {
        content: content || value.trim(),
        ...(estimatedPrice && Number.isFinite(estimatedPrice) ? { estimatedPrice } : {}),
    };
}
